module.exports = __webpack_public_path__ + "img/books.a547d4a5.png";